import { PORTAL_TIER_PRICES_ACTIONS, initialPortalTierPricesState } from './portalTierPrices.types'

/**
 * @param {import('./portalTierPrices.types').PortalTierPricesSlice} state
 * @param {Object} action
 */
export function portalTierPricesReducer(state = initialPortalTierPricesState, { type, payload }) {
  switch (type) {
    case PORTAL_TIER_PRICES_ACTIONS.SET_PORTAL_TIER_PRICES:
      return { ...state, data: payload }

    case PORTAL_TIER_PRICES_ACTIONS.SET_PORTAL_TIER_PRICE:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case PORTAL_TIER_PRICES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case PORTAL_TIER_PRICES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case PORTAL_TIER_PRICES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
